import { Box } from "@mui/material";

const ConstellationsQuiz = () => {
  return <Box>ConstellationsQuiz</Box>;
};
export default ConstellationsQuiz;
